import React from 'react';
import './Currencies.scss';

import {handleAuthError} from '../../globals';
import { createStore } from 'devextreme-aspnet-data';
import DataGrid, {
  Column,
  //Button,
  //Pager,
  //Paging,
  //FilterRow,
  //Lookup,
  Editing,
  Selection,
  //Summary,
  //GroupItem,
  //TotalItem,
  SearchPanel
} from 'devextreme-react/data-grid';

const serviceUrl = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Valuta'

const remoteDataSource = createStore({
  key: 'id',
  loadUrl: serviceUrl + '/GetAction',
  insertUrl: serviceUrl + '/InsertAction',
  updateUrl:serviceUrl + '/UpdateAction',
  deleteUrl: serviceUrl + '/DeleteAction',
  
  errorHandler: (error) => {
    handleAuthError(error);
  }
});

export default () => (
  <React.Fragment>
    <h2 className={'content-block'}>Valute</h2>
    <div className={'content-block'}>
      <div className={'dx-card responsive-paddings'}>

      <DataGrid
        dataSource={remoteDataSource}
        focusedRowEnabled={true}
        >
         <SearchPanel visible={true} width={240} placeholder="Cerca..." />
        <Selection mode="single" />
        <Editing
          mode="row"
          useIcons={true}
          allowAdding={true}
          allowDeleting={true}
          allowUpdating={true}     
        />
        <Column dataField="id" visible={false}/>
        <Column dataField="codice" />
        <Column dataField="descrizione" />
    
      </DataGrid>  
      </div>
    </div>
  </React.Fragment>
);
